export const studentGoalSettingIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Student Goal Setting is where you can view and download all of the student goal setting tools. WordFlight provides individual student trackers, multi student trackers, certificates, and stickers. All of these can be helpful tools for keeping students motivated towards their WordFlight goals. Contact your WordFlight Implementation Lead if you have any questions.'
  },
  {
    element: 'wf-knowledge-base-item:first-child',
    intro: 'Click here to download a document that provides information on all of the student goal setting tools that are available for you to use.'
  }
];